import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ObtenerFactura_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ObtenerFactura",
    rutaEndPoint: "/EnterpriseServices/Brm/Factura/obtenerFactura",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface ObtenerFactura_Entrada {
    ObtenerFacturaPDFRequest: ObtenerFacturaPDF;
}

export function builtObtenerFacturaEntradaInput(l_ObtenerFacturaPDFRequest: ObtenerFacturaPDF) {
    var retorno: ObtenerFactura_Entrada = {
        ObtenerFacturaPDFRequest:  l_ObtenerFacturaPDFRequest

    };
  
    return retorno;
}

export interface ObtenerFacturaPDF {
    UUID:          string;
    FechaTimbrado: Date;
    PAC:           string;
    SistemaEmisor: string;
    Empresa:       string;
}

export function builtObtenerFacturaPDFInput(l_UUID: string,l_FechaTimbrado: Date,l_PAC: string,l_SistemaEmisor: string,l_Empresa: string) {
    var retorno: ObtenerFacturaPDF = {
        UUID:          l_UUID,
        FechaTimbrado: l_FechaTimbrado,
        PAC:           l_PAC,
        SistemaEmisor: l_SistemaEmisor,
        Empresa:       l_Empresa
    };
  
    return retorno;
}

//SALIDA
export interface ObtenerFactura_Salida {
    EBMHeaderResponse:         EBMHeaderResponse;
    ObtenerFacturaPDFResponse: ObtenerFacturaPDFResponse;
}

export interface EBMHeaderResponse {
    ErrorTecnico: ErrorTecnico;
    ErrorNegocio: ErrorNegocio;
}

export interface ErrorNegocio {
    Estado:           string;
    CodigoError:      string;
    DescripcionError: string;
}

export interface ErrorTecnico {
    code:    string;
    detail:  string;
    Sistema: string;
}

export interface ObtenerFacturaPDFResponse {
    pdf:           string;
    respuesta:     string;
    respuestaDesc: string;
}


export type  ObtenerFactura_Respuesta = EncabezadoRespuestaInterna &
ObtenerFactura_Salida;